<template>
  <InstancesListTemplate
    :list="section.free_counts"
    :count="section.free_count"
  >
    <template #title v-if="section?.number">
      {{ $t("titles.Section") }}
      <!-- {{ $t("titles.Number symbol") }} -->
      {{ section?.number }}
    </template>
  </InstancesListTemplate>
</template>
<script>
import InstancesListTemplate from "./InstancesListTemplate.vue";

export default {
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  components: {
    InstancesListTemplate,
  },
  name: "SectionTooltip",
  data() {
    return {};
  },

  methods: {},
  computed: {},
};
</script>
